const ERP_ORDER_LIST_URL = "/v1/erp/order/list";
const ERP_ORDER_DETAILS_URL = "/v1/erp/order/detail";
const ORDER_LIST_URL = "/v1/order/list";
const ORDER_SINGLE_URL = "/v1/order/single";
const APPROVE_ORDER_URL = "/v1/order/approve";
const ERP_STATUS_CHANGE_URL = "/v1/order/erp-status-change";
const REMOVE_ORDER_URL = "/v1/order/remove";
const DELETE_ORDER_URL = "/v1/order/delete";
const UPDATE_ORDER_URL = "/v1/order/update";
const INVOICE_ORDER_CONTROL_URL = "/v1/order/invoiced-order-control";
const PENDING_ORDERS_URL = "/v1/order/pending-orders";
const ADD_ORDER_URL = "/v1/order/add";
const ERP_ORDER_ELOGO = "/v1/erp/e-logo/get-invoice";
const DEMO_PROJECT_CONTRACT_URL = "/v1/project/contract";
const ORDER_LIST_BY_PROJECT_CODE_URL = "/v1/order/listByProjectCode";
const ORDER_DELIVERY_DATE_CHANGE = "/v1/order/delivery-date-change";
const GET_PENDING_ORDERS_SUPPLIER = "/v1/current/supplier-list";
const GET_PENDING_ORDERS_PRODUCTS = "/v1/current/product-list";
const GET_PURCHASE_ORDER_LIST = "/v1/purchase-order/list";
const GET_PURCHASE_ORDER_SINGLE = "/v1/purchase-order/get";
const ADD_PURCHASE_ORDER = "/v1/purchase-order/add";
const DELETE_PURCHASE_ORDER = "/v1/purchase-order/delete";
const ORDER_STATUS_CHANGE = "/v1/purchase-order/order-status-change";
const ITEM_STATUS_CHANGE = "/v1/purchase-order/item-status-change";
const APPROVE_PURCHASE_ORDER = "/v1/purchase-order/approve";



const ORDER_API_URL_LIST = {
    ERP_ORDER_LIST_URL,
    ORDER_LIST_URL,
    ERP_ORDER_DETAILS_URL,
    ORDER_SINGLE_URL,
    APPROVE_ORDER_URL,
    ERP_STATUS_CHANGE_URL,
    REMOVE_ORDER_URL,
    UPDATE_ORDER_URL,
    INVOICE_ORDER_CONTROL_URL,
    PENDING_ORDERS_URL,
    ADD_ORDER_URL,
    ERP_ORDER_ELOGO,
    DEMO_PROJECT_CONTRACT_URL,
    ORDER_LIST_BY_PROJECT_CODE_URL,
    DELETE_ORDER_URL,
    ORDER_DELIVERY_DATE_CHANGE,
    GET_PENDING_ORDERS_SUPPLIER,
    GET_PENDING_ORDERS_PRODUCTS,
    GET_PURCHASE_ORDER_LIST,
    GET_PURCHASE_ORDER_SINGLE,
    ADD_PURCHASE_ORDER,
    DELETE_PURCHASE_ORDER,
    ORDER_STATUS_CHANGE,
    ITEM_STATUS_CHANGE,
    APPROVE_PURCHASE_ORDER,
}

export { ORDER_API_URL_LIST };